module.exports = __webpack_public_path__ + "img/operation2.09248016.png";